export class Resizer {
  constructor(container, camera, renderer, composer) {
    const onResize = () => {
      camera.aspect = container.clientWidth / container.clientHeight;
      camera.updateProjectionMatrix();

      renderer.setSize(container.clientWidth, container.clientHeight);
      renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));

      if (composer) {
        composer.setSize(container.clientWidth, container.clientHeight);
        composer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
      }
    };

    window.addEventListener("resize", onResize);

    onResize();
  }
}
